import { isEmpty, isNil } from 'lodash';

// Types.
type QueryParams = Record<string, string | number | boolean | null | undefined>;

// Helpers.
const getBaseWebSocketUrl = (): string => {
  if (import.meta.env.DEV) {
    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';

    return `${protocol}://${window.location.host}`;
  }

  return import.meta.env.VITE_RTI_SERVER_URL.replace(/^http/, 'ws');
};

export const buildWebSocketUrl = (
  path: string,
  queryParams?: QueryParams,
): string => {
  const baseWebSocketUrl = new URL(`${getBaseWebSocketUrl()}${path}`);

  if (!isNil(queryParams)) {
    Object.entries(queryParams).forEach(([key, value]) => {
      if (!isEmpty(value)) {
        baseWebSocketUrl.searchParams.set(key, String(value));
      }
    });
  }

  return baseWebSocketUrl.toString();
};
